export const areRectanglesEqual = (rectangleA: Rectangle, rectangleB: Rectangle | null | undefined) => {
  return (rectangleA.x === rectangleB?.x && rectangleA.y === rectangleB?.y && rectangleA.width === rectangleB?.width);
};

